export default "__VITE_ASSET__CcKDTVBH__"